import { getOr } from 'lodash/fp';
import { connect } from 'react-redux';
import {
  saveDefaultView,
  loadDefaultView,
  VIEW_TYPES,
} from 'actions/content/defaultView';

const DefaultViewProvider = ({ children, save, revert, currentView }) =>
  children({
    save,
    revert,
    // All possible values of the default value state
    viewTypes: VIEW_TYPES,
    // The current view (value of one of the VIEW_TYPES keys)
    currentView,
    // a function that is expected to be called with an object whose keys are
    // the keys of VIEW_TYPES, and whose values are the return value of each key
    // when it matches the current view.
    match: getOr(false, currentView),
  });

const mapStateToProps = state => ({
  currentView: state.defaultView,
});

const mapDispatchToProps = {
  save: saveDefaultView,
  revert: loadDefaultView,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DefaultViewProvider);
